import { render, staticRenderFns } from "./PeopleV2.vue?vue&type=template&id=29a60d69&scoped=true"
import script from "./PeopleV2.vue?vue&type=script&lang=js"
export * from "./PeopleV2.vue?vue&type=script&lang=js"
import style0 from "./PeopleV2.vue?vue&type=style&index=0&id=29a60d69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a60d69",
  null
  
)

export default component.exports